import { render, staticRenderFns } from "./CardContentRepeater.vue?vue&type=template&id=2319b540&scoped=true"
import script from "./CardContentRepeater.vue?vue&type=script&lang=js"
export * from "./CardContentRepeater.vue?vue&type=script&lang=js"
import style0 from "./CardContentRepeater.vue?vue&type=style&index=0&id=2319b540&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2319b540",
  null
  
)

export default component.exports